<template>
    <div class="cs-userNotFoundComponent cs-formBoxContainer" v-if="isUserNotFound">
        <div class="cs-form-header">
            <div class="cs-form-header__offerQuantity">{{offer.serviceQuantity}}</div>
            <div class="cs-form-header__close">
                <img v-on:click="$emit('closeComponent')" src="https://comprasocial.me/wp-content/uploads/2022/11/close-red.svg">
            </div>
        </div>
        <div class="cs-form-header__serviceName">
            {{offer.serviceName }}
        </div>

        <div class="cs-userNotFoundComponent__message">
            {{dictionary.areYouSureThatTheUsernameIs}} <span class="cs-userNotFoundComponent__username">{{user.username}}</span>
        </div>
        <div class="cs-formSubmitButton cs-formSubmitButton--emptyRed" v-on:click="$emit('resetForm')">{{dictionary.cancel}}</div>
        <div class="cs-formSubmitButton" v-on:click="$emit('addToCart')">{{dictionary.yesIConfirm}}</div>
    </div>
</template>

<script>
export default{
    name:'UserNotFoundComponent',
    props: ['isUserNotFound','dictionary', 'offer', 'user'],
    emits: ['resetForm', 'addToCart', 'closeComponent'],
    data: function(){
        return{
        }
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/form.scss";

.cs-userNotFoundComponent {
    &__message{
        font-size: 16px;
        font-weight: 400;
        text-align: center;
        color: #7a7a7a;
    }

    &__username{
        color: #c98ce5;
    }
}
</style>